import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-modal'
import Button from 'components/common/Button'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { postAnalytics } from 'actions/analytics'
import { setFormAccenture } from 'actions/assessment'

const PopupForm = () => {
    const dispatch = useDispatch()

    const {
        appState: { formAccentureStatus },
    } = useSelector(GET_STORE.ASSESSMENT)

    const [togglePopupLocale, setTogglePopupLocale] = useState(false)

    useEffect(() => {
        if (formAccentureStatus) {
            setTogglePopupLocale(true)
        }
    }, [formAccentureStatus])

    return (
        <Modal
            appElement={document.getElementById('root')}
            className="modal localeWidgetModal"
            isOpen={togglePopupLocale}
            onRequestClose={() => {
                setTogglePopupLocale(false)
                dispatch(postAnalytics('[FormAccentureModal] Close modal', null))
            }}
            overlayClassName="modalOverlay"
        >
            <button
                aria-label="Close modal"
                className="modalBack"
                onClick={() => {
                    dispatch(postAnalytics('[FormAccentureModal] Close modal', null))
                    setTogglePopupLocale(false)
                }}
            >
                ×
            </button>

            <h2 className="modalHeading">Claim Your Free Prize Now! </h2>

            <div className="modalButtons modalButtonRight">
                <Button
                    className=" modalButtonRight"
                    style={{ padding: 24, width: '100%' }}
                    cta
                    onClick={() => {
                        setTogglePopupLocale(false)
                        dispatch(setFormAccenture(false))
                        dispatch(postAnalytics('[FormAccentureModal] click answer', null))
                    }}
                    linkExternal
                    to="https://docs.google.com/forms/d/1wugGAq6hxIOa7yE5W5UwAy1szqguaUFjEBehwHeVsz8/edit"
                >
                    <span>Answer</span>
                </Button>
            </div>
        </Modal>
    )
}

export default PopupForm
